export default "__VITE_ASSET__wv70TTqL__"